<ngx-emoji
  [style.height.px]="size()"
  [emoji]="name()"
  [size]="size()"
></ngx-emoji>
